import { render, staticRenderFns } from "./BoardListLink.vue?vue&type=template&id=18277b73&scoped=true"
import script from "./BoardListLink.vue?vue&type=script&lang=js"
export * from "./BoardListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18277b73",
  null
  
)

export default component.exports